import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LoadingSpinner } from './styles-base';

export function LoadingItem() {
  const { t } = useTranslation();

  return (
    <LoadingItemBox>
      <LoadingSpinner />
      <span>{t('common:loading.with.ellipsis')}</span>
    </LoadingItemBox>
  );
}

/** ============================ styles ==================================== */
const LoadingItemBox = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--color-text-3);
`;
